import { ENV } from "../utils";

export class PotentialDamage {
  baseApi = ENV.BASE_API;

  async getPotentialDamages(accessToken, active = true) {
    const url = `${this.baseApi}/potential-damages?active=${active}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createPotentialDamage(accessToken, data) {
    const response = await fetch(`${this.baseApi}/add-potential-damage`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updatePotentialDamage(accessToken, id, data) {
    const response = await fetch(`${this.baseApi}/update-potential-damage/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deletePotentialDamage(accessToken, id) {
    const response = await fetch(`${this.baseApi}/delete-potential-damage/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
